import { useEffect } from "react";

const NEW_MESSAGES_CHECK_INTERVAL_IN_MS = 15000;

export const useMessageIndicator = ({
  setNewMessagesNumber,
  userData,
  showError,
}) => {
  const loadData = async () => {
    const data = {
      dashboardAccessToken: userData?.dashboardAccessToken,
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_V2_URL}/messages/new/count`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      const result = await response.json();

      if (response?.status !== 200 || result?.error) {
        showError(result?.message || result?.error || "Something went wrong");
        return;
      }

      setNewMessagesNumber(result?.quantity ?? 0);
    } catch (err) {
      showError(err?.error ?? err?.message ?? "Something went wrong");
    }
  };

  useEffect(() => {
    loadData();

    const interval = setInterval(() => {
      loadData();
    }, NEW_MESSAGES_CHECK_INTERVAL_IN_MS);

    // @ts-ignore
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {};
};
